var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39675 12.0123C9.39675 10.185 10.8774 8.70366 12.7047 8.70366C13.2477 8.70366 13.7565 8.83973 14.2075 9.07286C14.3323 9.13739 14.4894 9.06906 14.5103 8.93013C14.5558 8.62673 14.5807 8.31639 14.5807 8.00033C14.5807 4.50833 11.7394 1.66699 8.24742 1.66699C4.7554 1.66699 1.91406 4.50833 1.91406 8.00033C1.91406 11.4923 4.7554 14.3337 8.24742 14.3337C8.79628 14.3337 9.32902 14.2635 9.83722 14.1315C9.97308 14.0961 10.0241 13.9328 9.94662 13.8157C9.60315 13.2971 9.39675 12.6811 9.39675 12.0123Z",
    fill: "#009B62",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2818 13.7896C12.1818 13.7896 12.0867 13.7496 12.0167 13.6796L10.601 12.2639C10.4559 12.1188 10.4559 11.8787 10.601 11.7336C10.7461 11.5885 10.9862 11.5885 11.1313 11.7336L12.2818 12.8842L14.8531 10.3129C14.9982 10.1678 15.2383 10.1678 15.3834 10.3129C15.5285 10.458 15.5285 10.6981 15.3834 10.8432L12.547 13.6796C12.4769 13.7496 12.3819 13.7896 12.2818 13.7896Z",
    fill: "#009B62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96804 8.44641C8.96804 8.62241 8.87537 8.78507 8.7247 8.87574L6.60803 10.1424C6.52803 10.1904 6.43936 10.2131 6.35203 10.2131C6.18203 10.2131 6.01603 10.1271 5.9227 9.97041C5.7807 9.73307 5.85803 9.42641 6.0947 9.28441L7.96804 8.16307V5.71973C7.96804 5.44373 8.19204 5.21973 8.46804 5.21973C8.74404 5.21973 8.96804 5.44373 8.96804 5.71973V8.44641Z",
    fill: "#009B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerDone);
export default __webpack_public_path__ + "static/media/timer_done.5f48ef27874e9e6b5ba32b446b0acba0.svg";
export { ForwardRef as ReactComponent };